import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as searchActions from '../actions/search';
import { Menu, MenuItem, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { groupBy, map } from 'lodash';
import classNames from 'classnames';
import SearchIcon from '../images/icons/search.svg';

class EsriAutoComplete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            countryCode: 'USA',
            options: [],
            isLoading: false,
            showMoreFilters: false
        }

        this.renderOptions = this.renderOptions.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.clear = this.clear.bind(this);
    }

    renderOptions(results, menuProps) {
        let idx = 0;
        const grouped = groupBy(results, r => r.header);
        const items = Object.keys(grouped).map(header => {
            return [
                !!idx,
                /* <MenuHeader key={`${header}-header`}>
                    {header}
                </MenuHeader>, */
                map(grouped[header], state => {
                    const item =
                        <MenuItem key={idx} option={state} position={idx}>
                            {state.header}: {state.text}
                        </MenuItem>;

                    idx++;
                    return item;
                }),
            ];
        });

        return <Menu {...menuProps}>{items}</Menu>;
    }

    handleSearch(query) {
        if (!query) {
            return;
        }
        if (this.props.searchActions) {
            if (this.props.usePublicFetch) this.props.searchActions.fetchPublicAutoCompleteSuggestions(query);
            else this.props.searchActions.fetchAutoCompleteSuggestions(query);
        }
    }

    handleSubmit(e) {
        if (e && this.props.handleAutoComplete) {
            this.props.handleAutoComplete(e);
            //this.setState({showClearButton: (e && e.length > 0) ? true : false});
            if (this._typeahead && this.props.hideFocus) this._typeahead.getInstance().blur();
        }
    }

    onInputChange(e) {
        if (this.props.onInputChange) {
            this.props.onInputChange(e);
        }
    }

    onFocus(e) {
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    }

    onBlur(e) {
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    clear() {
        if (this._instance) {
            this._instance.clear();
        }
    }

    clearFilters = () => {
        if (this.props.onClearFilters) {
            this.props.onClearFilters()
        }
        this.props.searchActions.resetSearchFilters(this.props.defaultPropertyTypes);
    }

    removeFilter = (param1, param2) => {
        var searchFilters = Object.assign({}, this.props.searchFilters.Criteria);
        if (param1) delete searchFilters[param1];
        if (param2) delete searchFilters[param2];
        this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
    }

    removeFilterIndex = (filterName, filterIndex) => {
        const { searchFilters } = this.props;
        const { Criteria } = searchFilters;
        // get Criteria without [filterName], clone and mutate/splice. Only add back if not empty
        const { [filterName]: currentFilter, ...restCriteria } = Criteria;
        const newFilters = [...currentFilter];
        newFilters.splice(filterIndex, 1);
        const updateFilters = {
            Criteria: {
                ...restCriteria,
                ...(newFilters.length) && { [filterName]: newFilters }
            }
        }
        delete updateFilters.Criteria['mapbound'];
        this.props.searchActions.updateSearchFilters(updateFilters);
    }

    toggleShowMoreFilters = () => {
        this.setState({ showMoreFilters: !this.state.showMoreFilters });
    }

    getFilterChips = () => {
        var chips = [];
        const { searchFilters, showHideFilterButton } = this.props;
        let lastChipIndex = -1;
        if (searchFilters.Criteria) {
            const cityChips = searchFilters.Criteria.cities && searchFilters.Criteria.cities.length > 0 ?
                searchFilters.Criteria.cities.map((city, i) => {
                    return <span key={'chip_city_' + city} className="filter_chip_city" ref={el => this.citiesAdded = el} onMouseDown={() => this.removeFilterIndex('cities', i)}>City: {city}</span>
                }) : null;
            const zipCodeChips = searchFilters.Criteria.zipCodes && searchFilters.Criteria.zipCodes.length > 0 ?
                searchFilters.Criteria.zipCodes.map((zipCode, i) => {
                    return <span key={'chip_zip_code_' + zipCode} className="filter_chip_city" ref={el => this.zipCodesAdded = el} onMouseDown={() => this.removeFilterIndex('zipCodes', i)}>Zipcode: {zipCode}</span>
                }) : null;
            const subdivisionChips = searchFilters.Criteria.subdivisions && searchFilters.Criteria.subdivisions.length > 0 ?
                searchFilters.Criteria.subdivisions.map((subdivision, i) => {
                    return <span key={'chip_subdivision_' + subdivision} className="filter_chip_city" ref={el => this.subdivision = el} onMouseDown={() => this.removeFilterIndex('subdivisions', i)}>Neighborhood: {subdivision}</span>
                }) : null;
            const addressChips = searchFilters.Criteria.addresses && searchFilters.Criteria.addresses.length > 0 ?
                  searchFilters.Criteria.addresses.map((address, i) => {
                      return <span key={'chip_address_' + address} className="filter_chip_city" ref={el => this.address = el} onMouseDown={() => this.removeFilterIndex('addresses', i)}>Address: {address}</span>
                }) : null;

            if (addressChips != null){
              addressChips.forEach(chip => chips.push(chip));
            }
            if (cityChips !== null) {
                cityChips.forEach(chip => chips.push(chip));
            }

            if (zipCodeChips !== null) {
                zipCodeChips.forEach(chip => chips.push(chip));
            }

            if (subdivisionChips !== null) {
                subdivisionChips.forEach(chip => chips.push(chip));
            }
        }

        if (chips && chips.length > 0) {
            var moreBtn = null;
            var chipCount = chips.length;
            var remainingChips = chipCount - 1;

            if (window.innerWidth < 768 && showHideFilterButton) {
                moreBtn = (<span className="filter_chip_more" onClick={() => this.setState({ hideFilters: true })}>Hide Filters</span>);
            }

            if (chipCount > 1) {
                if (this.state.showMoreFilters) {
                    moreBtn = (<span className="filter_chip_more" onClick={this.toggleShowMoreFilters}>Fewer Filters</span>);
                }
                else {
                    moreBtn = (<span className="filter_chip_more" onClick={this.toggleShowMoreFilters}>{remainingChips} More Filter{remainingChips > 1 ? "s" : ""}</span>);
                }
            }

            lastChipIndex = chipCount - 1 >= 0 ? chipCount - 1 : 0
            return (<span className={classNames('filters_chip_wrapper', { 'full': this.state.showMoreFilters, 'd-none d-sm-flex': this.state.hideFilters })} ref={el => this.chipList = el}>{moreBtn}{this.state.showMoreFilters ? chips : chips[lastChipIndex]}</span>);

        }
        return null;
    }

    render() {
        const { autoCompleteAddresses, autoCompleteCities, autoCompleteZipCodes, autoCompleteSubdivisions } = this.props;
        var opts = [];
        if(autoCompleteCities && autoCompleteCities.length > 0){
            opts = opts.concat(autoCompleteCities.map(obj => {
                var tmp = {};
                tmp.header = "City";
                tmp.searchText = autoCompleteCities;
                tmp.text = obj.Text;
                tmp.key = obj.Key;
                return tmp;
            }));
        }
        if(autoCompleteSubdivisions && autoCompleteSubdivisions.length > 0){
            opts = opts.concat(autoCompleteSubdivisions.map(obj => {
                var tmp = {};
                tmp.header = "Neighborhood";
                tmp.searchText = autoCompleteSubdivisions;
                tmp.text = obj.Text;
                tmp.key = obj.Key;
                return tmp;
            }));
        }
        if (autoCompleteAddresses && autoCompleteAddresses.length > 0) {
            opts = opts.concat(autoCompleteAddresses.map(obj => {
                var tmp = {};
                tmp.header = "Address";
                tmp.searchText = autoCompleteAddresses;
                tmp.text = obj.Text;
                tmp.key = obj.Key;
                return tmp;
            }));
        }
        if(autoCompleteZipCodes && autoCompleteZipCodes.length > 0){
            opts = opts.concat(autoCompleteZipCodes.map(obj => {
                var tmp = {};
                tmp.header = "Zip Code";
                tmp.searchText = autoCompleteZipCodes;
                tmp.text = obj.Text;
                tmp.key = obj.Key;
                return tmp;
            }));
        }

        var config = {
            className: this.props.className ? "autocomp " + this.props.className : "autocomp",
            minLength: 3,
            align: "justify",
            options: opts,
            isLoading: this.props.isAutoCompleteLoading
        };

        return (
            <span className="autocomp_wrapper">
                <span className="filters_main_wrapper w-100">
                    {this.getFilterChips()}
                    <span className="input_wrapper w-100">
                        <span className="icon_search d-inline-block d-md-none"><img src={SearchIcon} alt="" /></span>
                        <AsyncTypeahead
                            ref={(component) => this._instance = component && component.getInstance ? component.getInstance() : this._typeahead}
                            {...config}
                            selected={[]}
                            placeholder={this.props.placeholder || "Search"}
                            labelKey={option => {
                                return `${option.header}: ${option.text}`;
                            }}
                            filterBy={['searchText', 'text']}
                            onSearch={this.handleSearch}
                            renderMenu={this.renderOptions}
                            onChange={this.handleSubmit}
                            onInputChange={this.onInputChange}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                            useCache={false}
                            delay={500}
                            id="typeahead"
                            inputProps={{ 'aria-autocomplete': 'off', autoComplete: 'off' }}
                        />
                    </span>
                </span>
                {(this.props.showClearButton) &&
                    <span className="buttons_wrapper">
                        <span className="btn_clear" onClick={this.clearFilters}>Clear</span>
                    </span>
                }
            </span>
        );
    }
}

const mapStateToProps = (state, props) => ({
    isAutoCompleteLoading: state.search.isAutoCompleteLoading || false,
    autoCompleteAddresses: state.search.autoCompleteAddresses || [],
    autoCompleteCities: state.search.autoCompleteCities || [],
    autoCompleteZipCodes: state.search.autoCompleteZipCodes || [],
    autoCompleteSubdivisions: state.search.autoCompleteSubdivisions || [],
    autoCompleteQuery: state.search.autoCompleteQuery || "",
    current: state.current || "",
    searchFilters: (state.search && state.search.filters) || {},
});

const mapDispatchToProps = dispatch => ({
    searchActions: bindActionCreators(searchActions, dispatch)
});

EsriAutoComplete.defaultProps = {
    showClearButton: true,
    usePublicFetch: false,
    showHideFilterButton: true
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(EsriAutoComplete);
